export default "__VITE_ASSET__DGrVv8g3__"